import React, { FC } from 'react';
import { useField } from 'formik';
import { FormControl, TextareaAutosize } from '@mui/material';
import classNames from 'classnames';
import { PanelWrapper } from './PanelWrapper';
import { FieldError } from '../fields/FieldError/FieldError';

interface InputPanelProps {
  body?: string;
  text?: string;
  rows?: number;
  name: string;
  placeholder?: string;
  footer?: string;
  fitContent?: boolean;
}

export const InputPanel: FC<InputPanelProps> = ({
  name,
  rows = 1,
  fitContent,
  placeholder,
  ...props
}) => {
  const [field, meta] = useField(name);

  return (
    <PanelWrapper {...props}>
      <FormControl fullWidth>
        <TextareaAutosize
          {...field}
          minRows={rows}
          maxRows={6}
          placeholder={placeholder}
          className={classNames(
            'p-2 border border-surface-2 bg-surface-2 rounded-md focus:bg-surface focus:border-accent outline-0 focus:outline-0 resize-none',
            {
              'w-full': !fitContent,
              'w-[50%]': fitContent,
            }
          )}
        />
        {!!meta.touched && !!meta.error && (
          <FieldError>{meta.error}</FieldError>
        )}
      </FormControl>
    </PanelWrapper>
  );
};
